import { ApplicationViewHeader } from '../../../components/application';

export default function AdminWorkspaceViewHeader({
  backNavigation,
  contextLabel = 'Admin workspace',
  ...props
}) {
  return (
    <ApplicationViewHeader
      {...props}
      backNavigation={backNavigation === undefined ? (
          <a className="dashboard-system__back-link" href="/app/admin">
            ← Back to admin workspace
          </a>
        ) : backNavigation}
      contextLabel={contextLabel}
    />
  );
}
